import { TypedDocumentNode, gql } from '@apollo/client';

import { RailCareTeamQuery, RailCareTeamQueryVariables } from './PatientCareTeam.queries.gql.types';
import { CareTeamClinicianFragment } from './PatientCareTeamInfo.fragments';

export const PATIENT_CARE_TEAM_QUERY: TypedDocumentNode<
    RailCareTeamQuery,
    RailCareTeamQueryVariables
> = gql`
    query RailCareTeam($patientId: UUID!) {
        patient(id: $patientId) {
            id
            careTeams {
                id
                clinicians {
                    ...CareTeamClinicianFragment
                }
            }
            permissions {
                id
                editCareTeam
            }
        }
    }
    ${CareTeamClinicianFragment}
`;
